import React from 'react';
import { HeartIcon } from 'lucide-react';
export function EmotionalSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-14">
          <div className="order-2 lg:order-1" data-id="element-15">
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full mb-6" data-id="element-16">
              <HeartIcon className="h-5 w-5" data-id="element-17" />
              <span className="font-semibold" data-id="element-18">Nuestra Misión</span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-19">
              Unimos a las familias, sin importar la distancia
            </h2>

            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-20">
              Sabemos lo importante que es mantener a tu familia conectada. Por
              eso trabajamos cada día para hacer que tus envíos lleguen rápido,
              seguros y con el amor que pones en cada paquete.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-21">
              Desde productos esenciales hasta alimentos frescos, nos aseguramos
              de que tus seres queridos en Cuba reciban exactamente lo que
              necesitan, cuando lo necesitan.
            </p>
          </div>

          <div className="order-1 lg:order-2" data-id="element-22">
            <div className="rounded-2xl overflow-hidden shadow-2xl" data-id="element-23">
              <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&h=600&fit=crop" alt="Familia feliz recibiendo envío" className="w-full h-full object-cover" data-id="element-24" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}